import React from 'react'
import {Carousel,message} from 'antd';
import { Route, Router, Link } from 'react-router-dom'
import createHistory from 'history/createHashHistory';
const history = createHistory();
import './index.css';
import NHFetch from "../../utils/NHFetch";
import {getLoginUser} from '@utils/NHCore';
const baseUrl = 'api/zhxg-yxwz/';
import NHModal from "@components/common/NHModal";
import UpdatePasswordForm from '../../app/pages/index/updatePasswordForm';
import {userLogout} from "../../app/actions/login";
export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sytp:[],//首页图片
            dhlm:[],//导航栏目
            settings:{},
            logoUUID:'', //LOGO图(对应文档库的UUID)
        }
    }

    componentDidMount(){
        const xsid = getLoginUser().userId;
        this.getYxwzLogo();
        this.getSytpList();
        this.getDhlmList();
        if (xsid && window.forcePasswordReset) {
            this.getStudentSfczmm(xsid);
        }
        setTimeout(()=>{
            let settings = {
                effect:'fade',
                dots: true,
                speed: 10000,
            }
            this.setState({
                settings:settings
            })
        },2000);
    }

    //获取迎新网站LOGO
    getYxwzLogo = () => {
        NHFetch("api/zhxg-yxwz/dhlm/getLogo","GET")
            .then(resData => {
                if(resData && resData.data){
                    this.setState({
                        logoUUID:resData.data
                    });
                }
            });
    };

    getDhlmList=()=>{
        let params = {}
        let xsid = getLoginUser()?getLoginUser().userId:'';
        if(xsid){
            params={
                xsfs:2,
            }
        }
        NHFetch("api/zhxg-yxwz/dhlm/getDhlmList","GET",params)
            .then(resData => {
                if(resData && resData.data){
                    this.setState({dhlm:resData.data});
                }
            });
    }

    getSytpList=()=>{
        NHFetch("api/zhxg-yxwz/sytp/getSytpList", "GET")
            .then(resData => {
                if(resData && resData.data){
                    this.setState({sytp:resData.data});
                }
            });
    }

    getStudentSfczmm = (xsid) => {
        NHFetch("/newStudent/getStudentSfczmm", 'get', {xsid}).then(
            resData => {
                if(resData && resData.data) {
                    let sfczmm = resData.data;
                    if (sfczmm == '0') {
                        this.nhModal.show();
                    }
                }
            }
        )
    }

    handleModalOk = () => {
        this.updatePasswordForm.validateFields((err, formData) => {
            if (err) {
                this.nhModal.stopLoading();
                return;
            }
            let oldPassWord = formData['oldPassWord'].trim();
            let newPassWord = formData['newPassWord'].trim();
            let verifyPassWord = formData['verifyPassWord'].trim();
            let i = 0;
            if (!oldPassWord) {
                i++;
                this.setFields('oldPassWord', '', '密码不能为空');
            }
            if (!newPassWord) {
                i++;
                this.setFields('newPassWord', '', '新密码不能为空');
            }
            if (!verifyPassWord) {
                i++;
                this.setFields('verifyPassWord', '', '确认密码不能为空');
            }

            if (i > 0) {
                return;
            }

            if (newPassWord !== verifyPassWord) {
                this.setFields('verifyPassWord', verifyPassWord, '新密码与确认密码不一致，请检查输入');
                return;
            }
            let params = {
                oldPassWord: oldPassWord,
                newPassWord: newPassWord,
            }
            NHFetch('/newStudent/updatePasswordCZ', 'POST', params).then(resData => {
                if (resData && resData.data) {
                    let data = resData.data;
                    if (data > 0) {
                        message.success('密码修改成功');
                        this.nhModal.close();
                        userLogout();
                    } else if (data == -2) {
                        message.warning('密码为空');
                    } else if (data == -3) {
                        message.warning('旧密码验证不通过，密码错误');
                        this.updatePasswordForm.setFields({
                            oldPassWord: {
                                value: oldPassWord,
                                errors: [new Error('旧密码验证不通过，密码错误。')],
                            },
                        });
                    } else {
                        message.warning('密码修改失败');
                    }
                } else {
                    message.warning('密码修改失败');
                }
                this.nhModal.stopLoading();
            }).catch(res => {
                message.error('密码修改异常');
                this.nhModal.stopLoading();
                return res;
            });
        });
    }

    handleCancel = () => {
        this.nhModal.show();
    }

    setFields = (name, value, message) => {
        let obj = {};
        obj[name] = {
            value: value,
            errors: [new Error(message)],
        }
        this.updatePasswordForm.setFields(obj);
        this.nhModal.stopLoading();
    }

    click=(dhlm)=>{
        let lmlx = dhlm['lmlx'];
        let flbz = dhlm['flbz'];
        let mkbz = dhlm['mkbz'];
        let flmid = dhlm['flmid'];
        let lmlj = dhlm['lmlj'];
        let pkid = dhlm['pkid'];
        let count= dhlm['childCount'];
        let isUnique= dhlm['isUnique'];

        if(lmlx=='3'){
            history.push({
                    pathname:'/'+mkbz,
                }
            );
        }else if(lmlx=='1'){
            if (isUnique === '1') {
                history.push({
                        pathname: '/notice/detail',
                        search: 'pkid=' + pkid,
                    }
                );
            } else {
                history.push({
                        pathname:'/notice',
                        search:'flbz='+flbz,
                    }
                );
            }
        }else if(lmlx=='2'){
                if(count>0){
                    history.push({
                            pathname:'/link',
                            search:'pkid='+pkid,
                        }
                    );
                }else{
                    window.open(lmlj);
                }
        }

    }

    render() {
        const settings = this.state.settings;
        const {logoUUID} = this.state;
        let show = false;
        if(JSON.stringify(settings)==="{}"){
            show = false
        }else{
            show = true;
        }
        let footer = [
            {text:'确定',type:'primary',onClick:this.handleModalOk}
        ];
        return (
            <div>
                <div styleName="top">
                    <div styleName="top_con">
                        <img src={logoUUID ? "anonymity/docrepo/download?attachmentId=" + logoUUID : ''} alt=""/>
                    </div>
                </div>
                <div styleName="list">
                    <div className="w1180">
                        {
                            this.state.dhlm.map((elem, index) => {
                            return (
                                <span key={index} styleName="item" onClick={()=>{
                                    this.click(elem);
                                }}>
                                    {elem.lmmc}
                                    {elem.sfrdlm_dm == "1" && <img src={require(`../../../assets/images/hot.png`)} style={{position:"relative",top:"-8px"}}/>}
                                    </span>
                                )})
                        }
                    </div>
                </div>
                <div className="_bg" styleName="banner">
                    {show?<Carousel {...settings} autoplay>
                        {this.state.sytp.map((elem, index) => {
                            let pkid = elem['PKID'];
                            return(
                                <div styleName="banner" key={index}>
                                    <img style={{width:'100%',height:'100%'}} src={"api/zhxg-yxwz/sytp/getPicture/"+pkid} alt=""/>
                                </div>
                            )
                        })}
                    </Carousel>:
                        this.state.sytp.length>0&&
                            <div styleName="banner">
                                 <img style={{width: '100%', height: '100%'}} src={"api/zhxg-yxwz/sytp/getPicture/" + this.state.sytp[0].PKID} alt=""/>
                            </div>
                    }
                </div>
                <NHModal
                    ref={modal => this.nhModal = modal} title={'密码修改'} onOk={this.handleModalOk}
                    footer={footer}
                    onCancel={this.handleCancel}
                    closable={false}
                >
                    <UpdatePasswordForm ref={modal => this.updatePasswordForm = modal} />
                </NHModal>
            </div>
        )
    }
}